import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { doCallback, formatDateTime, makePath } from 'functions.js';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// LOCAL PARTS
import DeleteButton from '../../tools/DeleteButton';

// STYLES
import styles from './dealTaskComment.module.scss';

// MAIN COMPONENT
const DealTaskComment = ({
  comment: {
    dsl_task_user_comment_id,
    user_comments,
    user_comments_date_created,
    user_comments_first_name,
    user_comments_last_name
  }
}) => {

  // CONTEXT
  const { refetchRecord } = useRecordContext() || {};

  // RENDER
  return (
    <div className={clsx(
      'comment-item',
      styles.comment
    )}>
      <div className={styles.header}>
        <div>
          {user_comments_first_name}&nbsp;{user_comments_last_name}
          <span className={styles.dateTime}>{formatDateTime(user_comments_date_created)}</span>
        </div>
        <DeleteButton args={{
          endpoint: makePath(ENDPOINTS.dealTasks.comment.delete, dsl_task_user_comment_id),
          onSuccess: () => doCallback(refetchRecord)
        }} />
      </div>
      <div className={styles.body}>{user_comments}</div>
    </div>
  );

};

// EXPORT
export default DealTaskComment;
